import * as React from 'react';
import { useToggleable } from '../../../../hooks';
import Modal from '../../../../Modal';
import MediaQuery from '../../../../MediaQuery/MediaQuery';
import SlideBottom from '../../../../SlideBottom';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useTheme } from '../../../../theme';
import CloseIcon from '../../../../CloseIcon/components/CloseIcon';
import { useConfig } from '../../../../context';
import Link from '../../../../Link';
import { createPortal } from 'react-dom';
const BoardingInfo = ({ renderTrigger }) => {
    const { isOpen, open, close } = useToggleable(false);
    const { t } = useTranslation('FlightStatus');
    const { BoardingInfo: css } = useTheme('FlightStatus');
    const { FlightStatus: { playMarketURL, appStoreURL } } = useConfig();
    const renderContent = useCallback(() => {
        return (React.createElement("div", { className: css.content },
            React.createElement("h4", { className: css.heading }, t('Boarding information')),
            React.createElement("p", { className: css.text }, t('Install the app, log in and receive notifications about flight status changes')),
            (playMarketURL || appStoreURL) && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: css.icons },
                    playMarketURL && (React.createElement(Link, { action: playMarketURL },
                        React.createElement("img", { className: css.icon, src: require('../../icons/googlePlay.svg'), alt: "google play logo" }))),
                    appStoreURL && (React.createElement(Link, { action: appStoreURL },
                        React.createElement("img", { className: css.icon, src: require('../../icons/appStore.svg'), alt: "google play logo" }))))))));
    }, []);
    return (React.createElement(React.Fragment, null,
        renderTrigger({ open: open }),
        React.createElement(MediaQuery, { minWidth: 'mobile' },
            React.createElement(Modal, { closeButtonRenderer: onClick => {
                    return React.createElement(CloseIcon, { className: css.closeIcon, onClick: onClick });
                }, open: isOpen, onClose: close, maxWidth: 'xs' }, renderContent())),
        React.createElement(MediaQuery, { maxWidth: 'mobile' }, createPortal(React.createElement(SlideBottom, { isOpen: isOpen, onClose: close }, renderContent()), document.body))));
};
export default BoardingInfo;
